<template>
    <ReactPage>
      <game-leaderboard-report-page></game-leaderboard-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "GameLeaderboardReport",
    components: {
      ReactPage
    }
  }
  </script>